export default __webpack_public_path__ + "static/media/temp_1.de86afc3.png";